import { ai2htmlResize } from './utils/ai2html-resizer';

ai2htmlResize('#g-calif-maps-wfl-box');
